import React, { useCallback, useState } from 'react';
import { Controller } from 'react-hook-form';
import { TextField, Autocomplete } from '@mui/material';
import api from 'utils/api';

const CategorySelector = ({ control, size = 'medium' }) => {
  const [options, setOptions] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const [open, setOpen] = useState(false);

  const searchCategories = (val) => {
    const trimmed = val?.trim();
    if (!trimmed) {
      setOptions([]);
      return;
    }

    api.get(`/category?name=${trimmed}`).then((res) => {
      setOptions(res.content || []);
    });
  };

  const getLabel = useCallback((o) => o?.name ?? '', []);

  return (
    <Controller
      name="categories"
      control={control}
      render={({ field: { onChange, value } }) => {
        const val =
          Array.isArray(value) ? value :
          typeof value === 'object' ? [value] :
          value ? options.filter((o) => o.categoryId === value) : [];

        return (
          <Autocomplete
            multiple
            size={size}
            options={options}
            value={val}
            inputValue={inputValue}
            getOptionLabel={getLabel}
            open={open}
            onOpen={() => {
              if (inputValue.trim().length > 0) setOpen(true);
            }}
            onClose={() => setOpen(false)}
            onInputChange={(event, newInputValue, reason) => {
              if (reason === 'input') {
                setInputValue(newInputValue);
                if (newInputValue.trim().length > 0) {
                  setOpen(true);
                  searchCategories(newInputValue);
                } else {
                  setOpen(false);
                  setOptions([]);
                }
              }
            }}
            onChange={(e, val) => {
              onChange(val);
              setInputValue('');
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                fullWidth
                helperText="Search for the categories that best represent your business."
                label="Categories"
                variant="outlined"
              />
            )}
            ChipProps={{ color: 'primary' }}
          />
        );
      }}
    />
  );
};

export default CategorySelector;
